<script>
import { nextTick } from "vue";
import { getClasses } from "../api";
import ClassCard from "../components/classes/class_card.vue";
import EmptyState from "../components/global/empty_state.vue";

export default {
  name: "ClassesView",
  components: {
    ClassCard,
    EmptyState,
  },
  data() {
    return {
      loading: true,
      error: "",
      classes: [],
      count: 0,
      limit: null,
      currentPage: 1,
      classDeleted: "",
    };
  },
  mounted() {
    // user was re-routed after deleting a class
    if (this.$route.query.deleted) {
      this.classDeleted = "Class was successfully deleted.";
    }

    this.fetchClasses();
  },
  methods: {
    async fetchClasses() {
      await nextTick();

      try {
        const { data } = await getClasses({ page: this.currentPage });

        this.classes = data.classes;
        this.limit = data.limit;
        this.count = data.count;

        this.loading = false;
        this.error = false;
      } catch (error) {
        this.error = error.response?.data?.error;
        this.loading = false;
      }
    },
  },
};
</script>

<template>
  <eg-b-container>
    <div v-if="classes.length > 0 && !loading" class="text-right svg-container">
      <img src="../assets/illustrations/classes-illustration.svg" alt="" />
    </div>
    <section v-if="loading || error">
      <eg-b-row v-if="loading" class="mt-4">
        <eg-b-col class="mb-3" cols="4">
          <eg-b-skeleton-img no-aspect height="150px"></eg-b-skeleton-img>
        </eg-b-col>
        <eg-b-col class="mb-3" cols="4">
          <eg-b-skeleton-img no-aspect height="150px"></eg-b-skeleton-img>
        </eg-b-col>
        <eg-b-col class="mb-3" cols="4">
          <eg-b-skeleton-img no-aspect height="150px"></eg-b-skeleton-img>
        </eg-b-col>
        <eg-b-col cols="4">
          <eg-b-skeleton-img no-aspect height="150px"></eg-b-skeleton-img>
        </eg-b-col>
        <eg-b-col cols="4">
          <eg-b-skeleton-img no-aspect height="150px"></eg-b-skeleton-img>
        </eg-b-col>
        <eg-b-col cols="4">
          <eg-b-skeleton-img no-aspect height="150px"></eg-b-skeleton-img>
        </eg-b-col>
      </eg-b-row>
      <eg-b-row v-if="error">
        <eg-b-col>
          <eg-b-alert variant="danger" show>{{ error }}</eg-b-alert>
        </eg-b-col>
      </eg-b-row>
    </section>
    <section>
      <template v-if="classes.length > 0">
        <eg-b-row class="mb-3">
          <eg-b-col v-if="classDeleted" lg="12">
            <eg-b-alert variant="success" show>
              {{ classDeleted }}
            </eg-b-alert>
          </eg-b-col>

          <eg-b-col lg="8" md="12">
            <h1>{{ $t("common.classes") }}</h1>
          </eg-b-col>
          <eg-b-col class="text-right create-rubric-column" lg="4" md="12">
            <eg-b-button variant="info" to="/class/new">{{
              $t("common.newClass")
            }}</eg-b-button>
          </eg-b-col>
        </eg-b-row>
        <eg-b-row>
          <eg-b-col v-for="foundClass in classes" :key="foundClass.id" lg="4">
            <class-card :user-class="foundClass" />
          </eg-b-col>
        </eg-b-row>
        <eg-b-row>
          <eg-b-col>
            <div class="d-flex justify-content-center">
              <eg-b-pagination
                v-model="currentPage"
                :total-rows="count"
                :per-page="limit"
                @change="fetchClasses"
              >
              </eg-b-pagination>
            </div>
          </eg-b-col>
        </eg-b-row>
      </template>
      <empty-state
        v-else-if="!loading && classes.length == 0"
        class="mt-5"
        :title="$t('assignments.classes.noClassesYet')"
        :description="$t('assignments.classes.noClassesDescription')"
        :button-text="$t('common.newClass')"
        button-path="/class/new"
      >
        <img
          src="../assets/illustrations/empty-state-classes.svg"
          alt="EssayGrader Empty State"
        />
      </empty-state>
    </section>
  </eg-b-container>
</template>
